import {useDeepCompareMemoize} from 'hooks/useDeepCompareMemoize.js'
import {useEffect} from 'react'

export function useCompareDeepEffect(callback, dependencies) {
  useEffect(
    callback,
    dependencies.map(useDeepCompareMemoize)
  )
}

// like useEffect, except it does a deep compare on dependency array elements

// see https://stackoverflow.com/questions/54095994/react-useeffect-comparing-objects
